export default "__VITE_ASSET__T4PJPMuI__"